//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link, NavLink } from 'react-router-dom'
import { AuthContext } from '../context/auth-context'
import Footer from '../components/UIElements/Footer'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import SearchByLeagueOrVenue from '../components/UIElements/SearchByLeagueOrVenue'
import FilterByTeam from '../components/UIElements/FilterByTeam'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'

const LeagueSchedule = () => {
	console.log('inside LeagueSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [allLeagueGames, setAllLeagueGames] = useState([])
	const [showPreviousGames, setShowPreviousGames] = useState(false)
	//const [divisionName, setDivisionName] = useState()

	const leagueId = useParams().leagueId
	const divisionName = useParams().divisionName

	const auth = useContext(AuthContext)

	console.log('inside LeagueSchedule.  divisionName is ' + divisionName)

	//Get all games for the entire League (all teams).  getLeagueSchedule in the league-controller
	useEffect(() => {
		//console.log('INSIDE USE EFFECT')
		const sendRequest = async () => {
			setIsLoading(true)
			setAllLeagueGames([])
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/schedule/${leagueId}`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllLeagueGames(responseData.allLeagueGamesArray)
				//setDivisionName(responseData.divisionName)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueId])
	//
	//
	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${months[game.date.substr(0, 2)]} ${game.date.substr(
			3,
			2,
		)}`
	}

	const formatGameTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour]
	}

	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		const scoreParts = game.score.split('-').map((score) => score.trim())

		if (scoreParts.length !== 2) {
			return game.score
		}

		const firstScore = Number(scoreParts[0])
		const secondScore = Number(scoreParts[1])

		if (Number.isNaN(firstScore) || Number.isNaN(secondScore)) {
			return game.score
		}

		/*
		Mobile cards always display:

		HOME SCORE - VISITOR SCORE
	*/

		if (game.winner === game.homeTeamId) {
			const homeScore = Math.max(firstScore, secondScore)
			const visitorScore = Math.min(firstScore, secondScore)

			return `${homeScore} - ${visitorScore}`
		}

		if (game.winner === game.visitorTeamId) {
			const homeScore = Math.min(firstScore, secondScore)
			const visitorScore = Math.max(firstScore, secondScore)

			return `${homeScore} - ${visitorScore}`
		}

		return `${firstScore} - ${secondScore}`
	}

	const getGameStatus = (game) => {
		if (!game.score) {
			return ''
		}

		if (game.status === 'Shootout') {
			return 'SO'
		}

		if (game.status === 'Overtime') {
			return 'OT'
		}

		return 'FINAL'
	}
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	const isGameOlderThanTwoDays = (game) => {
		if (!game.date) {
			return false
		}

		// Supports BOTH:
		// 08-30-2026
		// 08/30/2026
		const [month, day, year] = game.date.split(/[/-]/).map(Number)

		const gameDate = new Date(year, month - 1, day)
		gameDate.setHours(0, 0, 0, 0)

		const today = new Date()
		today.setHours(0, 0, 0, 0)

		const twoDaysAgo = new Date(today)
		twoDaysAgo.setDate(today.getDate() - 2)

		return gameDate < twoDaysAgo
	}
	//
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}
	//
	//
	let dateBlock
	dateBlock = []
	if (!isLoading && allLeagueGames.length === 0) {
		return (
			<React.Fragment>
				{/* <AdminNavigation /> */}
				<SchedulesHomeNavigation />
				{/* <SearchByLeagueOrVenue /> */}
				<FilterByTeam />
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (!isLoading && allLeagueGames.length !== 0) {
		dateBlock.push(
			<div className='Schedule'>
				<div className='leagueScheduleMobileTitle'>
					<h1>{allLeagueGames[0].leagueName}</h1>

					{divisionName && <h2>{divisionName} Division</h2>}

					<p className='leagueScheduleMobileSeason'>
						{allLeagueGames[0].session} {allLeagueGames[0].year}
					</p>

					<div className='leagueScheduleMobileDivider'></div>

					<div className='leagueScheduleMobileFilter'>
						<FilterByTeam leagueId={leagueId} divisionName={divisionName} />
					</div>
				</div>
				{!divisionName && (
					<div className='leagueScheduleDesktopTitle'>
						<h1>{allLeagueGames[0].leagueName}</h1>
						<h3>{allLeagueGames[0].session + ' ' + allLeagueGames[0].year}</h3>
					</div>
				)}
				{divisionName && (
					<div className='leagueScheduleDesktopTitle'>
						<h1>
							{allLeagueGames[0].leagueName +
								' - ' +
								divisionName +
								' Division - ' +
								allLeagueGames[0].session +
								' ' +
								allLeagueGames[0].year}
						</h1>
					</div>
				)}
				<h3>League Schedule</h3>
				<p>(Click on the final score of a game to see a Game Summary)</p>
				{/* <table id='schedulePlayers'> */}
				<table id='leagueScheduleDisplay'>
					<thead>
						<tr>
							<th>Date/Time</th>
							{/* <th>Time</th> */}
							{/* <th>Game or Event</th> */}
							{/* <th>Status</th> */}
							<th></th>
							{/* <th></th> */}
							{auth.isLoggedIn && <th></th>}
							<th>Winner</th>
							<th>Score</th>
							<th>Venue</th>
						</tr>
					</thead>
					<tbody>
						{allLeagueGames.map((game, key) => {
							// if (game.venueName === venue) {
							return (
								<tr key={key}>
									<td>
										{game.dayOfWeek}
										{', '}
										{game.date.substr(0, 2) === '01' &&
											'Jan. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '02' &&
											'Feb. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '03' &&
											'Mar. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '04' &&
											'Apr. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '05' &&
											'May ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '06' &&
											'June ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '07' &&
											'July ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '08' &&
											'Aug. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '09' &&
											'Sept. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '10' &&
											'Oct. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '11' &&
											'Nov. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '12' &&
											'Dec. ' + game.date.substr(3, 2)}
										<br></br>
										{game.time.substr(0, 2) === '00' &&
											'12:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '01' &&
											'1:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '02' &&
											'2:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '03' &&
											'3:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '04' &&
											'4:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '05' &&
											'5:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '06' &&
											'6:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '07' &&
											'7:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '08' &&
											'8:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '09' &&
											'9:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '10' &&
											'10:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '11' &&
											'11:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '12' &&
											'12:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '13' &&
											'1:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '14' &&
											'2:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '15' &&
											'3:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '16' &&
											'4:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '17' &&
											'5:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '18' &&
											'6:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '19' &&
											'7:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '20' &&
											'8:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '21' &&
											'9:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '22' &&
											'10:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '23' &&
											'11:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '24' &&
											'12:' + game.time.substr(3, 2) + ' am'}
										{/* {' - '}
										{game.endTime.substr(0, 2) === '01' &&
											'1:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '02' &&
											'2:' + game.time.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '03' &&
											'3:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '04' &&
											'4:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '05' &&
											'5:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '06' &&
											'6:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '07' &&
											'7:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '08' &&
											'8:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '09' &&
											'9:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '10' &&
											'10:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '11' &&
											'11:' + game.endTime.substr(3, 2) + ' am'}
										{game.endTime.substr(0, 2) === '12' &&
											'12:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '13' &&
											'1:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '14' &&
											'2:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '15' &&
											'3:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '16' &&
											'4:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '17' &&
											'5:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '18' &&
											'6:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '19' &&
											'7:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '20' &&
											'8:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '21' &&
											'9:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '22' &&
											'10:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '23' &&
											'11:' + game.endTime.substr(3, 2) + ' pm'}
										{game.endTime.substr(0, 2) === '24' &&
											'12:' + game.endTime.substr(3, 2) + ' am'} */}
									</td>

									<td>
										{game.visitorTeamSeed > 0 &&
											'(' + game.visitorTeamSeed + ') '}
										{game.visitorTeamName && game.visitorTeamName}
										<br></br>
										{' @ '}
										{<span>{<br />}</span>}
										{game.homeTeamSeed > 0 && '(' + game.homeTeamSeed + ') '}
										{game.homeTeamName && game.homeTeamName}
										{game.description && (
											<div style={{ color: 'red', fontWeight: 'bold' }}>
												{'('}
												{game.description}
												{')'}
											</div>
										)}
										{game.championship && (
											<div
												style={{
													color: 'red',
													fontWeight: 'bold',
												}}
											>
												CHAMPIONSHIP GAME
											</div>
										)}
									</td>
									{auth.isLoggedIn && (
										<td>
											{game.playoff &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/playoffGameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}
											{!game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/gameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{game.lastSubmittedByEmail && (
												<div className='fullScheduleSubmittedBy'>
													Submitted by:
													<br />
													{game.lastSubmittedByEmail}
												</div>
											)}

											{game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												(game.homeTeamName === 'TBD' ||
													game.visitorTeamName === 'TBD') && (
													<NavLink
														className='navlinksEnterTeams'
														//to={`/admin/updatePlayoffGame/${game._id}`}
														to={`/admin/updateGame/${game._id}`}
														exact
													>
														Teams
													</NavLink>
												)}
										</td>
									)}
									{game.homeTeamId && game.winner === game.homeTeamId && (
										<td>{game.homeTeamName}</td>
									)}
									{game.visitorTeamId && game.winner === game.visitorTeamId && (
										<td>{game.visitorTeamName}</td>
									)}
									{game.status &&
										game.status !== 'TBP' && //< - - - had to put this in due to the Kraly fix
										game.winner !== game.homeTeamId &&
										game.winner !== game.visitorTeamId && <td>TIE</td>}
									{/* // */}
									{!game.score && <td></td>}
									{/* // */}
									<td>
										{game.score && (
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`/gameSummary/${game._id}`}
											>
												{game.score}
												{game.status === 'Overtime' && ' (OT)'}
												{game.status === 'Shootout' && ' (SO)'}
											</Link>
										)}
									</td>
									<td>{game.venueName}</td>
								</tr>
							)
							//}
						})}
					</tbody>
				</table>
				<div
					onClick={() => setShowPreviousGames((prev) => !prev)}
					style={{
						textAlign: 'center',
						marginTop: '1rem',
						marginBottom: '1rem',
						fontSize: '0.85rem',
						fontWeight: '600',
						textDecoration: 'underline',
						cursor: 'pointer',
					}}
				>
					{showPreviousGames
						? 'Hide previous games'
						: 'Click to see previous games'}
				</div>

				<div className='scheduleCardsMobile leagueScheduleCardsMobile'>
					{allLeagueGames
						.filter((game) => {
							if (showPreviousGames) {
								return true
							}

							return !isGameOlderThanTwoDays(game)
						})
						.map((game, key) => {
							return (
								<div
									className={`scheduleCard ${
										game.playoff || game.championship || game.description
											? 'scheduleCardSpecial'
											: ''
									}`}
									key={`league-mobile-${game._id || key}`}
								>
									<div className='scheduleCard__header'>
										<div>{formatGameDate(game)}</div>

										<div className='scheduleCard__league'>
											{game.playoff
												? 'PLAYOFF'
												: game.divisionName || divisionName || game.leagueName}
										</div>

										<div>{formatGameTime(game)}</div>
									</div>

									<div className='scheduleCard__body'>
										{/* Home team is always on the left */}
										<div className='scheduleCard__team'>
											{/* <span className='scheduleCard__teamLabel'>HOME</span> */}

											<span
												className={
													game.winner === game.homeTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.homeTeamSeed > 0 && `(${game.homeTeamSeed}) `}
												{game.homeTeamName || 'TBD'}
											</span>
										</div>

										<div className='scheduleCard__scoreBox'>
											{game.score ? (
												<Link
													to={`/gameSummary/${game._id}`}
													className='scheduleCard__score'
												>
													{getDisplayScore(game)}
												</Link>
											) : (
												<div className='scheduleCard__score'>TBP</div>
											)}

											{game.score && (
												<div className='scheduleCard__status'>
													{getGameStatus(game)}
												</div>
											)}
										</div>

										{/* Visitor team is always on the right */}
										<div className='scheduleCard__team'>
											{/* <span className='scheduleCard__teamLabel'>VISITOR</span> */}

											<span
												className={
													game.winner === game.visitorTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.visitorTeamSeed > 0 &&
													`(${game.visitorTeamSeed}) `}
												{game.visitorTeamName || 'TBD'}
											</span>
										</div>
									</div>

									<div className='scheduleCard__venue'>📍 {game.venueName}</div>

									{game.description && (
										<div className='scheduleCard__description'>
											{game.description}
										</div>
									)}

									{game.championship && (
										<div className='scheduleCard__description'>
											CHAMPIONSHIP GAME
										</div>
									)}

									{auth.isLoggedIn && (
										<div className='scheduleCard__admin'>
											{game.playoff &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/playoffGameResults2/${game._id}`}
													>
														Results
													</NavLink>
												)}
											{!game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/gameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{game.lastSubmittedByEmail && (
												<div className='fullScheduleSubmittedBy'>
													Submitted by:
													<br />
													{game.lastSubmittedByEmail}
												</div>
											)}

											{game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												(game.homeTeamName === 'TBD' ||
													game.visitorTeamName === 'TBD') && (
													<NavLink
														className='navlinksEnterTeams'
														//to={`/admin/updatePlayoffGame/${game._id}`}
														to={`/admin/updateGame/${game._id}`}
													>
														Teams
													</NavLink>
												)}
										</div>
									)}
								</div>
							)
						})}
				</div>
			</div>,
		)
		// }
		//)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation leagueId={leagueId} />
				{/* <SearchByLeagueOrVenue /> */}
				{/* <FilterByTeam /> */}
				<div className='leagueScheduleDesktopFilter'>
					<FilterByTeam leagueId={leagueId} divisionName={divisionName} />
				</div>
				{dateBlock && dateBlock}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default LeagueSchedule
